import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CompanyResponse } from '@features/company/company.model';
import { ClientCompanyRequest, ClientCompanyResponse } from '../../client.model';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ClientCompanyFormComponent } from '../client-company-form/client-company-form.component';

@Component({
  selector: 'app-client-company-modal',
  imports: [MatDialogModule, ...SharedMaterialUIModule, ClientCompanyFormComponent],
  templateUrl: './client-company-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientCompanyModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ClientCompanyModalComponent>);

  readonly clientId = input.required<string>();
  readonly companies = input<CompanyResponse[]>([]);
  readonly initialValue = input<ClientCompanyResponse | null>(null);
  readonly saving = input(false);

  protected onSubmit(request: ClientCompanyRequest): void {
    this.dialogRef.close(request);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected get title(): string {
    return this.initialValue() ? 'Edit client company' : 'Create client company';
  }
}